import json from "../Data.js";
import { sliderQuestion, Mask, nextSliderAudio } from "./Splide.js";

class Modal {

	constructor() {
		this.triggers = document.querySelectorAll('.js-modal');
		// this.close = document.querySelectorAll('.js-close-modal');
		this.modals = document.querySelectorAll('.modal');

		this.onCreateContent = () => {};
		this.listenerOpen();
	}

	listenerOpen() {

		this.triggers.forEach( el => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				this.openModal(e, el);
			}, false);
		});

	}

	listenerClose() {

		document.querySelectorAll('.js-close-modal').forEach( el => {
			el.addEventListener('click', (e) => {
				nextSliderAudio.load();
				e.preventDefault();
				this.closeModal(e);
			}, false);
		});

	}

	static createModal(id, type) {

		let item, img, answer;

		item = json.data.find(item => item.id === id);

		if (type === 'a') {
			img = item.modal_a_img;
			answer = item.modal_a;
		} else {
			img = item.modal_b_img;
			answer = item.modal_b;
		}

		let img_class = `modal__img`;
		const img_classes = {
			"modal_img_jakes":'small',
			"modal_img_mask_rage":"small",
			"modal_img_mask":"small",
			"modal_img_news":"small",
			"modal_img_recorder":"small",
			"modal_img_security":"small"
		};
		if (img_classes[img]) img_class += ` modal__img--${img_classes[img]}`;

		return `<div class="modal">

			<div class="modal-inner">

				<div class="wrapper wrapper--auto">

					<div class="modal__body">

						<div class="flex flex-direction-sm--column flex-direction-md--row justify-content-sm--center align-items-sm--center">

							<div class="col col--1 width-sm--100 flex-md--2">

								<div class="${img_class}">

									<picture>
										<source srcset="assets/img/${img}@2x.webp" type="image/webp">
										<img src="assets/img/${img}@2x.png" alt="${item.question}" width="455" height="568">
									</picture>

								</div>

							</div>

							<div class="col col--2 width-sm--100 flex-md--3">

								<div class="container">

									<div class="wysihtml wysihtml--modal">${answer}</div>

									<div class="row">${item.modal_button}</div>

								</div>

							</div>

						</div>

						<div class="urban-mask"></div>

					</div>

				</div>

			</div>

		</div>`;

	}

	async openModal(e) {

		const cl_target = e.currentTarget;

		document.body.classList.add('modal-body', 'noscroll');

		let modalId = cl_target.dataset.modal_id;
		let modalType = cl_target.dataset.modal_type;

		const container = document.querySelector('main');
		const containerModal = document.createElement('div');
		containerModal.classList.add('modal__container');
		containerModal.innerHTML = Modal.createModal(modalId, modalType);
		container.append(containerModal);

		this.listenerClose();


		await Mask.delay(10)
		const modal = containerModal.querySelector('.modal');
		modal.classList.add('modal-visible');

		this.mask = modal.querySelector('.urban-mask');

		this.onCreateContent();
		
		await Mask.show(this.mask, 'urban-mask');

		modal.classList.add('modal-visible-inner');

		await Mask.hide(this.mask, 'urban-mask');

	}

	async closeModal() {

		document.body.classList.remove('modal-body', 'noscroll');

		await Mask.show(this.mask, 'urban-mask');

		const modal = document.querySelector('.modal');
		modal.classList.remove('modal-visible-inner');

		Mask.hide(this.mask, 'urban-mask');
		await Mask.show();
		// modal.classList.remove('modal-visible');
		// await Mask.delay(500);
		document.querySelector('.modal__container').remove();

		sliderQuestion.go('>');

		await Mask.hide();

	}

}

export default Modal;


